const getStringValue = (value: string | null | undefined): string => value ?? '';

export default getStringValue;
